import Cookies from 'js-cookie';
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { ErrorModal } from '../modals';
import { validateForm, createAd, getAdState } from '../api';
import * as Opt from '../components/editor/Helpers';
import VBLoadingScreen from "@vb-js-commons/vbLoadingScreen";
import ColorSelector from '../components/editor/fields/ColorSelector';
import styled from 'styled-components';

import { LoginContext } from "../components/login/context/LoginContext";

const StyledModal  = styled(Modal)`
   z-index: 1100;
`

class SellerLandingForm extends React.Component {
    static contextType = LoginContext;

    constructor() {
        super();

        this.state = {
            formData: {
                arrangement: Window.react_data.lists.arrangements[0].value //set the default value to the first option
            },
            errors: {},
            activeTab: 1,
            popupChoice: null,
        }
    }

    componentDidMount(){

        const LoginContext = this.context;
        const currentCookie = Cookies.get(`ad_id_${LoginContext.isLogged}`)
        if (currentCookie){
            this.setState({oldCookie:currentCookie, old_url_magic_link: "/auctions/create/?ad_id="+currentCookie})
        }
    }

    
    handleCreateAdClick = (e) => {
        /* Always creates a draft on a user (not logged in, if their email is in the correct format)
            then can do three more things
            1. Show error in form fields
            2. Show continueOnAdModal
            3. Redirect user to auctions/create */
        e.preventDefault();
        const LoginContext = this.context;

        let checkList = ['arrangement'];
    
        const validation = validateForm(this.state.formData, checkList, false);
        const has_error = Object.values(validation).some(val => val);
    
        if (has_error) {
            this.setState({ errors: validation });
            return;
        }

        const has_cookie_ad = Cookies.get(`ad_id_${LoginContext.isLogged}`);
    
        if (has_cookie_ad && this.state.formData.arrangement !== 'grot') {
            this.setState({ loading: false, continueOnAdModal: true });
        } else {
            this.createRedirectToAd();
        }
    };
    
    createRedirectToAd() {
        const LoginContext = this.context;

        this.setState({ loading: true })

        if (this.state.formData.arrangement == "grot") {
            window.location = "/auctions/grot/create/"
        } else {
            const adIdCookie = Cookies.get(`ad_id_${LoginContext.isLogged}`);
        
            if(!adIdCookie){
                createAd({ arrangement: this.state.formData.arrangement }).then((resp) => {
                    if (resp.ok) {
                        resp.json().then((json) => {
                            Cookies.set(`ad_id_${LoginContext.isLogged}`, json.ad_id)
                            Cookies.set('curr_step', 1)
                            window.location = "/auctions/create/"
                        })
                    } else {
                        this.setState({ loading: false, errorModal: true })
                    }
                });
            } else {
                //goto already created ad
                Cookies.set(`ad_id_${LoginContext.isLogged}`, adIdCookie)
                Cookies.set('curr_step', 1)
                getAdState(adIdCookie).then((resp) => resp.json()).then((json) => {
                    if(json.state == 10) {
                        window.location = "/auctions/create/"
                    } else if(json.state == 20) {
                        window.location = "/auctions/" + adIdCookie.toString() + "/review/";
                    } else if(json.state >= 40) {
                        Cookies.remove("ad_id");
                        window.location = "/auctions/" + json.id.toString() + "/";
                    } else {
                        window.location = "/auctions/" + adIdCookie.toString() + "/"
                    }
                })
            }
        }
    }

    handleContinueClick = () => {
        const LoginContext = this.context;

        if (this.state.popupChoice === 'continue') {
            this.createRedirectToAd()

        } else if (this.state.popupChoice === 'new') {
            Cookies.remove(`ad_id_${LoginContext.isLogged}`);
            this.createRedirectToAd();
        }

        this.setState({ continueOnAdModal: false });
    };
    

    render() {
        const LoginContext = this.context;

        return (<>
            <VBLoadingScreen show_loading={this.state.loading} />
            <div className={`bg-${this.props.backgroundColor} ${this.props.textColor}`} style={{ borderRadius: "40px", padding: "32px" }}>
                <div>
                    <p className="n-fs-3 fw-medium">Skapa din annons</p>
                    <p>Välj åtgärd</p>
                    <form>
                        <ul style={{ display: 'flex', flexWrap: 'wrap', listStyleType: 'none', padding: 0 }}>
                            {Window.react_data.lists.arrangements.map((tab, index) => (
                                <li key={index} style={{ marginTop: "12px", marginRight: "8px" }}>
                                    <button className='fs-6' style={{ borderRadius: "8px", padding: '4px 8px', border: 'none',backgroundColor: this.state.activeTab === index + 1 ? '#023436' : '#EEE8E2', color: this.state.activeTab === index + 1 ? '#FFFFFF' : '#025650',}} onClick={(e) => { e.preventDefault(); this.setState({ activeTab: index + 1, formData: { ...this.state.formData, arrangement: tab.value } }) }}>
                                        {tab.label}
                                    </button>
                                </li>
                            ))}
                        </ul>

                        <div className='mt-4 d-flex'>
                            <a id='handle-create-ad' href="#" className='n-btn btn-core w-100' style={{cursor: "pointer"}} onClick={(e) => {
                                if(LoginContext.isLogged) {
                                    this.handleCreateAdClick(e) 
                                } else {
                                    LoginContext.open({action: 'handle-create-ad'})
                                }
                            }}>Kom igång<span><img className='ms-2' width="18px" height="18px" src={Window.static_path + "img/icons/arrow-black.svg"} /></span></a>
                        </div>
                    </form>
                </div>

                <StyledModal show={this.state.continueOnAdModal} onHide={() => this.setState({ continueOnAdModal: false })} size="lg" contentClassName="bg-neutral-cloud-200 p-3" centered>
                    <Modal.Body className="neutral-charcoal pb-0"> 
                        <p className="n-fs-4 fw-medium mb-1">Skapa Annons</p>
                        <p className='n-fs-7'>Du kan även se alla dina annonsutkast under <a className="supp-pine text-decoration-underline" href="/my-account/">Mina sidor</a>.</p>

                        <div className="card mt-4 p-3" role="button" onClick={() => this.setState({popupChoice: 'continue'})} style={{ border: `solid 2px ${this.state.popupChoice == 'continue' ? "#6A58C6" : "transparent"}` }}>
                            <p className='n-fs-5 fw-medium mb-2 d-flex justify-content-between'>Fortsätt på påbörjad annons{this.state.popupChoice == 'continue' && <img src={`${Window.static_path}img/icons/checkmark.svg`} alt="Checkmark" height="22px" />}</p>
                            <p className='n-fs-6 mb-0'>Återuppta där du lämnade och gör din annons redo för publicering.</p>
                        </div>

                        <div className="card mt-4 p-3" role="button" onClick={() => this.setState({popupChoice: 'new'})} style={{ border: `solid 2px ${this.state.popupChoice == 'new' ? "#6A58C6" : "transparent"}` }}>
                            <p className='n-fs-5 fw-medium mb-2 d-flex justify-content-between'>Skapa ny annons{this.state.popupChoice == 'new' && <img src={`${Window.static_path}img/icons/checkmark.svg`} alt="Checkmark" height="22px" />}</p>
                            <p className='n-fs-6 mb-0'>Börja från grunden och skapa din perfekta annons.</p>
                        </div>
                    </Modal.Body>

                    <Modal.Footer className="justify-content-center justify-content-lg-end border-0 mt-4">
                        <div className='float-end'>
                            <button type="button" className="n-btn btn-charcoal btn-ghost neutral-charcoal me-2" onClick={() => this.setState({ continueOnAdModal: false })}>Avbryt</button>
                            <button type="button" className="n-btn btn-forest-green" disabled={!this.state.popupChoice} onClick={this.handleContinueClick}>Fortsätt
                                <span>
                                    <img className={`${!this.state.popupChoice ? 'neutral-stone-filter' : 'white-filter'} ms-2`} width="18px" height="18px" src={Window.static_path + "img/icons/arrow-black.svg"} />
                                </span>
                            </button>
                        </div>
                    </Modal.Footer>
                </StyledModal>

                <ErrorModal show={this.state.errorModal} onToggle={() => this.setState({errorModal: !this.state.errorModal})} />
            </div>
        </>
        )
    }
}

SellerLandingForm.defaultProps = {
    textColor: "neutral-charcoal",
    backgroundColor: "white",
}

SellerLandingForm.fields = {
    backgroundColor: {
        type: "custom",
        render: (props) => <ColorSelector {...props} />
    },
    textColor: {
        type: "select",
        options: Opt.colorVariables
    },

}
export default SellerLandingForm;
